var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSign = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 46,
  height: 48,
  viewBox: "0 0 46 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M38.1495 16.8008L45.3439 10.3248C45.5503 10.1416 45.6687 9.876 45.6687 9.6C45.6687 9.324 45.5503 9.0592 45.3471 8.8784L38.1495 2.4008H22.7311V0.8C22.7311 0.3576 22.3727 0 21.9311 0C21.4895 0 21.1311 0.3576 21.1311 0.8V2.4008H7.04865C5.55025 2.4008 4.33185 3.6192 4.33185 5.1176V14.0824C4.33185 15.5808 5.55025 16.8 7.04865 16.8H21.1319V18.4H7.85026L0.651855 24.8784C0.447855 25.0624 0.331055 25.3248 0.331055 25.6C0.331055 25.8752 0.447855 26.1376 0.652655 26.3224L7.85026 32.8H21.1311V47.2C21.1311 47.6424 21.4895 48 21.9311 48C22.3727 48 22.7311 47.6424 22.7311 47.2V32.8H39.2143C40.7127 32.8 41.9311 31.5816 41.9311 30.0832V21.1168C41.9311 19.6184 40.7127 18.4 39.2143 18.4H22.7311V16.8008H38.1495Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSign, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_sign.15831adb.svg";
export { ForwardRef as ReactComponent };